<template>
<div class="product-page-premium bg-light min-vh-100 py-5" v-if="producto">
    <div class="container">
        <div class="product-card-full bg-white shadow-lg rounded-20 overflow-hidden">
            <div class="row m-0">
                <!-- Left: Image Gallery -->
                <div class="col-lg-6 p-0 bg-white">
                    <div class="main-display-container p-4">
                        <img :src="`${dominio}/img/productos/${producto.imagenes[0].nombre}`" 
                             class="img-fluid rounded-25 shadow-sm main-img" alt="Producto">
                    </div>
                    <div class="thumbnails-row d-flex gap-3 px-4 pb-4 overflow-auto">
                        <div v-for="(img, index) in producto.imagenes" :key="index" 
                             class="thumb-box-premium" :class="{'active': index === 0}">
                            <img :src="`${dominio}/img/productos/${img.nombre}`" class="img-fluid rounded-10">
                        </div>
                    </div>
                </div>

                <!-- Right: Product Config -->
                <div class="col-lg-6 p-4 p-md-5 bg-white border-start">
                    <nav aria-label="breadcrumb" class="mb-3">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><router-link to="/tienda">Tienda</router-link></li>
                            <li class="breadcrumb-item active">{{producto.nombre}}</li>
                        </ol>
                    </nav>

                    <h1 class="product-title-premium text-brand-purple mb-2">{{producto.nombre}}</h1>
                    <p class="product-subtitle-premium text-muted mb-4">LUPA Fabrica de Empaques | Diseño Personalizado</p>

                    <div class="price-banner mb-4">
                        <span class="price-label">Desde</span>
                        <span class="price-value text-brand-green"> $34.50 USD</span>
                        <span class="price-meta"> / Unidad</span>
                    </div>

                    <div class="specs-grid row mb-4">
                        <div class="col-md-6 mb-3" v-for="(items, tipo) in atributosTienda" :key="tipo">
                            <label class="premium-label">{{ tipo }}</label>
                            <select class="form-select premium-select" v-model="specsSeleccionadas[tipo]" @change="cotizarPrecio">
                                <option value="">Seleccione {{ tipo }}</option>
                                <option v-for="item in items" :key="item.id" :value="item.nombre">{{ item.nombre }}</option>
                            </select>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label class="premium-label d-flex justify-content-between">
                                Cantidad
                                <span class="text-muted small">Quntidad <i class="fa fa-chevron-down"></i></span>
                            </label>
                            <input type="number" class="form-control premium-select" v-model="cantidad" @change="cotizarPrecio">
                        </div>
                    </div>

                    <div class="product-description-premium mb-4">
                        <h5 class="section-title text-brand-purple">DESCRIPCIÓN</h5>
                        <p class="text-muted">{{ producto.description || 'Nuestras cajas premium están diseñadas para ofrecer la mejor presentación y protección a sus productos.' }}</p>
                    </div>

                    <div class="cart-action-section pt-4 border-top">
                        <div v-if="matchFound" class="alert alert-success-premium mb-3">
                            <i class="fa fa-check-circle"></i> ¡Precio histórico encontrado para esta configuración!
                        </div>
                        <div v-else-if="cotizacionMensaje" class="alert alert-info-premium mb-3">
                            <i class="fa fa-calculator"></i> {{ cotizacionMensaje }}
                            <div v-if="detallesCalculo && detallesCalculo.papel" class="mt-2 small border-top pt-2">
                                <strong>Tamaños totales:</strong> {{ detallesCalculo.papel.total_tamanos }} 
                                <span class="text-muted">(Base + Sobrante)</span>
                                <br>
                                <strong>Pliegos necesarios:</strong> {{ detallesCalculo.papel.pliegos }}
                                <br>
                                <strong>Valor total papel:</strong> ${{ detallesCalculo.papel.costo_total.toLocaleString() }} 
                                <span class="text-muted small">(${{ detallesCalculo.papel.precio_pliego }} por pliego)</span>
                            </div>
                        </div>
                        
                        <div class="d-flex justify-content-between align-items-end mb-3">
                            <div class="total-summary">
                                <span class="total-label">TOTAL DEL PEDIDO</span>
                                <div class="total-amount text-brand-green">${{ (producto.valor_total || 0).toLocaleString() }}.00 USD</div>
                            </div>
                            <div class="hex-ref text-muted small">(#6ab04c)</div>
                        </div>

                        <button class="btn btn-brand-purple-lg w-100" @click="addToCart">
                            <i class="fa fa-shopping-cart me-2"></i> AGREGAR AL CARRITO
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'

export default {
    name: 'ProductoView',
    data() {
        return {
            producto: null,
            cantidad: 100,
            atributosTienda: {},
            specsSeleccionadas: {
                'Tinta': '',
                'Papel': '',
                'Acabado': '',
                'Terminado': ''
            },
            matchFound: false,
            cotizacionMensaje: '',
            detallesCalculo: null
        }
    },
    computed: {
        ...mapState(['dominio', 'products'])
    },
    methods: {
        fetchProduct() {
            const id = this.$route.params.id;
            // Intentar buscar en el store primero
            let list = this.products.data || this.products;
            if (Array.isArray(list)) {
                this.producto = list.find(p => p.id == id);
            }
            
            // Si no está en el store (acceso directo), cargarlo vía API (mocked for now as we use store)
            if (!this.producto) {
                // ... lógica de fetch API
            }
        },
        getAtributosTienda() {
            axios.get(this.dominio + '/api/tienda/atributos').then(response => {
                this.atributosTienda = response.data;
            });
        },
        cotizarPrecio() {
            if (!this.producto) return;
            let especificaciones = Object.keys(this.specsSeleccionadas).map(key => ({
                titulo: key,
                valor: this.specsSeleccionadas[key]
            })).filter(s => s.valor);

            axios.post(this.dominio + '/api/tienda/cotizar', {
                articulo_id: this.producto.id,
                cantidad: this.cantidad,
                especificaciones: especificaciones
            }).then(response => {
                this.producto.valor_total = response.data.total;
                if (response.data.match_found) {
                    this.matchFound = true;
                    this.cotizacionMensaje = '';
                    this.detallesCalculo = null;
                } else {
                    this.matchFound = false;
                    this.cotizacionMensaje = response.data.mensaje;
                    this.detallesCalculo = response.data.detalles_calculo;
                }
            });
        },
        addToCart() {
            // Lógica de agregar al carrito
            this.$store.commit('saveToCart', this.producto, this.cantidad);
            this.$router.push('/checkout');
        }
    },
    created() {
        this.fetchProduct();
        this.getAtributosTienda();
    }
}
</script>

<style scoped>
.rounded-20 { border-radius: 20px; }
.rounded-25 { border-radius: 25px; }
.rounded-10 { border-radius: 10px; }

.product-card-full {
    border: none;
    min-height: 600px;
}

/* Colors */
.text-brand-purple { color: #7d3c98; }
.text-brand-green { color: #6ab04c; }

/* Image section */
.main-img {
    width: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}
.thumb-box-premium {
    width: 100px;
    height: 100px;
    padding: 3px;
    border: 2px solid #eee;
    border-radius: 12px;
    cursor: pointer;
}
.thumb-box-premium.active { border-color: #7d3c98; }

/* Pricing */
.price-banner { display: flex; align-items: baseline; gap: 8px; }
.price-value { font-size: 2.5rem; font-weight: 800; }
.price-label { font-size: 1.2rem; font-weight: 600; color: #666; }

/* Config */
.premium-label { font-weight: 700; font-size: 0.9rem; margin-bottom: 8px; }
.premium-select {
    border: 1px solid #7d3c98;
    border-radius: 12px;
    height: 50px;
    background-color: #fcfcfc;
}

/* Description */
.section-title { font-size: 0.8rem; letter-spacing: 2px; font-weight: 800; margin-bottom: 15px; }

/* Footer */
.total-label { font-size: 0.8rem; font-weight: 700; color: #999; }
.total-amount { font-size: 2rem; font-weight: 800; }
.btn-brand-purple-lg {
    background: #7d3c98;
    color: white;
    border: none;
    padding: 18px;
    border-radius: 35px;
    font-weight: 800;
    font-size: 1.2rem;
    box-shadow: 0 10px 25px rgba(125, 60, 152, 0.4);
    transition: all 0.3s;
}
.btn-brand-purple-lg:hover {
    transform: translateY(-3px);
    background: #6a3381;
}

.alert-success-premium {
    background: #f0fdf4;
    border: 1px solid #6ab04c;
    color: #166534;
    border-radius: 10px;
    padding: 12px;
    font-size: 0.9rem;
}

.alert-info-premium {
    background: #f0f9ff;
    border: 1px solid #3498db;
    color: #2980b9;
    border-radius: 10px;
    padding: 12px;
    font-size: 0.9rem;
}
</style>
